import type { Block } from "building-types/blocks/blockTypes";
import type { Table } from "common/data/table";
import { blocksOnLevel } from "./blocksOnLevel";

export function levelHasHalfStory(levelId: string | undefined, blocks: Table<Block>) {
  const levelBlocks = blocksOnLevel(levelId, blocks);

  for (const block of levelBlocks) {
    if (block.isHalfStory) {
      return true;
    }
  }

  return false;
}
